import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Grid, Avatar, Typography, Button, Icon, Hidden } from "@material-ui/core";
import Parser from "html-react-parser";
import {Helmet} from "react-helmet";
import { client } from "../../config/apollo";
import {
  parentContainer,
  webFont,
  textBlack,
  primaryColor,
  textGrey,
  fontColor
} from "../../config/theme";
import Header from "../../components/Header";
import { GET_POST_SLUG } from "../../graphql/queries/posts";
const defaultChefImg = "/images/orange-logo-white-bg.webp";

class PostDetail extends Component {
  state = {
    postId: null,
    post: {},
    liked: false,
    favourite: false,
    likedCount: 0,
    fromScreen: ''
  };

  getDetails = (slug) => {
    client
      .query({
        query: GET_POST_SLUG,
        variables: {
          slug
        }
      })
      .then(postDetails => {
        if (postDetails.data) {
          this.setState({ post: postDetails.data.postBySlug });
        }
      })
      .catch(err => {
        this.props.history.push("/");
      });
  };

  componentDidMount() {
    if (this.props.match) {
      if ( this.props.match.params ) {
        if ( this.props.match.params.slug ) {
          this.getDetails(this.props.match.params.slug);
        }
        else {
          this.props.history.push("/");
        }
      }
      else {
        this.props.history.push("/");
      }
    } else {
      this.props.history.push("/");
    }
  }

  render() {
    const { post } = this.state;
    const { savedPosts, viewAsDiner } = this.props;

    let postImg = null;
    if (post.media) {
      if (post.media.length > 0) {
        const length = post.media.length;
        const index = post.media.findIndex(item => item.size === "MEDIUM");
        if (index < 0) {
          postImg = post.media[length - 1].url;
        } else {
          postImg = post.media[index].url;
        }
      }
    }


    return (
      <div style={parentContainer}>
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: 60 }}>
            <Header history={this.props.history} />
            <Helmet>
              <title>
                {post ? post.title : 'Cuisine Crafters'}
              </title>
              <meta name="description" content={post ? post.title : 'Cuisine Crafters'} />
              <link rel={"canonical"} href={`https://cuisinecrafters.net/post/${post ? post.postSlug : ''}`} />
            </Helmet>
          </Grid>

          <Grid className="saved-item-container ipad-width" container direction="row">
            <Grid item xs={12}>
              <Grid container direction="row">
                <Grid data-test-id={"postdet-chefimg"} item xs={3} sm={3} md={3} lg={2}>
                  <Hidden smDown>
                    <Avatar
                      src={post.profilePic ? post.profilePic : defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImg}
                    />
                  </Hidden>
                  <Hidden mdUp>
                    <Avatar
                      src={post.profilePic ? post.profilePic : defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImgiPad}
                    />
                  </Hidden>
                </Grid>

                <Grid item xs={6} sm={5} md={6} lg={8} style={{ paddingTop: 10, paddingLeft: 20 }}>
                  <Typography
                    data-test-id={"postdet-name"}
                    variant="h5"
                    style={{ ...style.setFont }}
                    gutterBottom={false}
                  >
                    {post.chefName}
                  </Typography>
                  <Typography
                    data-test-id={"postdet-date"}
                    variant="body1"
                    style={{
                      ...style.setFont,
                      ...style.setFontGrey
                    }}
                    gutterBottom={true}
                  >
                    On {moment(Number(post.createdAt)).format("DD MMM YYYY")}
                  </Typography>
                  <Typography
                    data-test-id={"postdet-tags"}
                    variant="body2"
                    style={{
                      ...style.setFont,
                      ...style.setFontGrey,
                      marginTop: 20
                    }}
                    gutterBottom={true}
                  >
                    {!!post.tags ? post.tags.toString().replace(/,/g, ", ") : ""}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: 63 }}>
                <Grid data-test-id={"postdet-title"} item xs={12}>
                  <Typography
                    variant="h4"
                    style={style.setFont}
                    gutterBottom={true}
                  >
                    {post.title}
                  </Typography>

                  {postImg && (
                    <Grid style={{ marginTop: 43 }}>
                      <img
                        data-test-id={"postdet-img"}
                        src={postImg}
                        style={{
                          width: "100%",
                          minHeight: 400,
                          maxHeight: 650,
                          objectFit: "cover",
                          marginBottom: 30,
                          borderRadius: 5,
                        }}
                      />
                    </Grid>
                  )}

                  <div style={style.setFont}>
                    {post.body ? Parser(post.body) : ""}
                  </div>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 60 }} />
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </div>
    );
  }
}
const mapPropsToState = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    viewAsDiner: state.user.viewAsDiner,
  };
};

const PostDetails = connect(mapPropsToState)(PostDetail);

export default PostDetails;

const style = {
  avatarImg: {
    width: 180,
    height: 180,
    borderRadius: 90
  },
  avatarImgiPad: {
    width: 150,
    height: 150,
    borderRadius: 75
  },
  setFont: {
    fontFamily: webFont
  },
  setFontGrey: {
    color: textGrey
  },
  btnDishTypeSelected: {
    borderRadius: "50%",
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    color: fontColor,
    backgroundColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10
  },
  dishTypeDet: {
    fontSize: 10
  }
};
